import { List, Modal, Popup, Tabs } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { FileOutline } from "antd-mobile-icons";
import PsContext from "../../context";
import {
  APP_TYPE,
  attendanceYear,
  baseUrl,
  groupByMultiple,
  momentDate,
  MuiModalWindow,
  NoData,
  semesterValue,
  upperCase,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import OnlinePay from "./onlinePay";
import OnlinePay_Receipt from "./onlinePay_Receipt";
import Fee_ReceiptPrint from "./fee_receiptPrint";

const MyFees = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);

  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);

  const [totalBalance, setTotalBalance] = useState(0);
  const [showFeeModal, setShowFeeModal] = useState(false);
  const [viewData, setViewData] = useState([]);
  const [billList, setBillList] = useState([]);
  const [unpaidList, setUnPaidList] = useState([]);

  const [showPay, setShowPay] = useState(false);
  const [activeTab, setActiveTab] = useState("unpaid");
  const [showUnpaidDetails, setShowUnpaidDetails] = useState(false);
  const [unPaidSingleData, setUnPaidSingleData] = useState([]);

  const [acknowldgements, setAcknowldgements] = useState([]);
  const [printAck, setPrintAck] = useState(false);
  const [printBill, setPrintBill] = useState(false);
  const [printAckData, setPrintAckData] = useState([]);
  const [startHour, setStartHour] = useState(9);
  const [endHour, setEndHour] = useState(16);
  const [allowPayment, setAllowPayment] = useState(false);
  const [paymentOpenDate, setPaymentOpenDate] = useState();

  const [payScreenType, setPayScreenType] = useState("bysem");

  // const currentHour = new Date().getHours();
  // const isInTimeRange = currentHour >= 10 && currentHour < 12;

  const currentDate = new Date();

  const currentHour = currentDate.getHours();
  const currentMinute = currentDate.getMinutes();

  const formatTime = (hour, minute) => {
    const ampm = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
    const formattedMinute = minute < 10 ? `0${minute}` : minute;
    return `${formattedHour}:${formattedMinute} ${ampm}`;
  };

  const startTime = formatTime(startHour, 0);
  const endTime = formatTime(endHour, 0);

  const isInTimeRange = currentHour >= startHour && currentHour < endHour;

  useEffect(() => {
    loadMyFees();
  }, []);

  const loadMyFees = () => {
    context.setLoader(true);
    setTotalBalance(0);
    setDataList([]);
    setDataView([]);
    const form = new FormData();
    form.append("pay_year", attendanceYear(context.user.semester));
    axios.post(ServiceUrl.STUDENTS.MY_FEES, form).then((res) => {
      if (res["data"].status == "1") {
        setPayScreenType(res.data.screen_type);
        setStartHour(res.data.start_time);
        setEndHour(res.data.end_time);
        setAllowPayment(res.data.allow_payment == "1" ? true : false);
        setPaymentOpenDate(res.data.payment_open_date);
        let d = groupByMultiple(res["data"].data, function (obj) {
          return [obj.semester];
        });
        let dt = res.data.data;
        let paid = dt.filter((item) => item.bill_uuid);
        let plist = groupByMultiple(paid, function (obj) {
          return [obj.semester];
        });
        let unpaid = dt.filter((item) => !item.bill_uuid);
        let uplist = groupByMultiple(unpaid, function (obj) {
          return [obj.semester];
        });

        let ack = res.data.acknowldged;
        if (ack) {
          ack = groupByMultiple(ack, function (obj) {
            return [obj.order_uuid];
          });
          setAcknowldgements(ack);
        }

        if (uplist.length < 1) setActiveTab("paid");

        setBillList(plist);
        setUnPaidList(uplist);
        setDataList(res["data"].data);
        setDataView(d);
        setTotalBalance(res["data"].balance);
      }
      context.setLoader(false);
    });
  };

  const semTotal = (items, type = false) => {
    let s = items;
    let total = 0;
    if (type == "paid") {
      s = items.filter((item) => item.bill_id);
    } else if (type == "unpaid") {
      s = items.filter((item) => !item.bill_id);
    }
    s.map((item) => (total = parseFloat(total) + parseFloat(item.fee_amount)));

    return parseFloat(total).toFixed(2);
  };

  const handleFeeClick = (items) => {
    setViewData(items);
    setShowFeeModal(true);
  };

  const getTypeRecords = (items, type) => {
    let s = items;
    if (type == "paid") {
      s = items.filter((item) => item.bill_id);
    } else if (type == "unpaid") {
      s = items.filter((item) => !item.bill_id);
    }
    return s;
  };

  const handlePayClick = (items) => {
    setViewData(items);
    setShowPay(true);
  };

  const getBills = (items) => {
    let d = groupByMultiple(items, function (obj) {
      return [obj.bill_uuid];
    });

    d = d.sort((a, b) => {
      return b[0].bill_no - a[0].bill_no;
    });

    return d.map((item) => (
      <List.Item
        prefix={<FileOutline />}
        description={momentDate(item[0].bill_date, "DD-MMM-YYYY")}
        extra={<>Rs. {itemsTotal(item)}</>}
        onClick={(d) => viewBillClick(item, "Bill")}
      >
        {item[0].bill_no}
      </List.Item>
    ));
  };

  const getBillPaidList = (items, ack = false) => {
    let rv = [];
    //getTypeRecords(items, "paid").map((item, i) => {
    let nullList = items.filter((item) => !item.fee_category_group_id);

    let notNullList = items.filter((item) => item.fee_category_group_id);

    let d = groupByMultiple(notNullList, function (obj) {
      return [obj.fee_category_group_id];
    });
    d.map((item, i) => {
      rv.push(
        <List.Item extra={itemsTotal(item)}>
          {item[0].fee_category_group_name}
        </List.Item>
      );
    });

    nullList.map((item, i) => {
      rv.push(
        <List.Item extra={<>{item.fee_amount}</>}>
          {item.category_name}
        </List.Item>
      );
    });
    return <List>{rv}</List>;
  };

  const viewBillClick = (items, type = "Bill") => {
    const title =
      type == "Bill" ? `Bill - ${items[0].bill_no}` : `${items[0].order_no}`;
    const ackstatus = upperCase(type) == "BILL" ? false : true;

    Modal.show({
      title: title,
      showCloseButton: true,
      content: <>{getBillPaidList(items, ackstatus)}</>,
      actions: context.allowedAccess("stu_mob_online_fee_pay", "action_print")
        ? [
            {
              key: "print_ack",
              text: "Download",
              primary: true,
              onClick: () => printClick(items, ackstatus),
            },
          ]
        : [],
    });
  };

  const itemsTotal = (items) => {
    let total = 0;
    items.map(
      (item) => (total = parseFloat(total) + parseFloat(item.fee_amount))
    );
    return parseFloat(total).toFixed(2);
  };

  const closeUnpaidPopup = () => {
    setShowUnpaidDetails(false);
    setUnPaidSingleData([]);
  };

  const printClick = (items, status) => {
    if (status) {
      let durl = `${baseUrl}${ServiceUrl.STUDENTS.DOWNLOAD.PAYMENT_ACKNOWLDGEMENT}${items[0].order_uuid}`;
      if (APP_TYPE == "SAAS") durl += `?sadb=${context.dbPostfix}`;
      window.open(durl);
    } else {
      let durl = `${baseUrl}${ServiceUrl.STUDENTS.DOWNLOAD.PAID_FEE_RECEIPT}${items[0].bill_uuid}`;
      if (APP_TYPE == "SAAS") durl += `?sadb=${context.dbPostfix}`;
      window.open(durl);
      /* setPrintAckData(items);
      if (status) setPrintAck(true);
      else setPrintBill(true);*/
    }
  };

  const printSuccess = () => {
    setPrintAckData([]);
    setPrintAck(false);
    setPrintBill(false);
  };

  return (
    <>
      <Header title="Fees" backAction={[]} />
      <div>
        <div className="container-sm">
          <Tabs
            className="bg-white theme-text"
            activeKey={activeTab}
            onChange={(k) => setActiveTab(k)}
          >
            <Tabs.Tab
              title={
                <>
                  FEE DUES{" "}
                  {parseFloat(totalBalance) > 0 && (
                    <span> - {totalBalance}</span>
                  )}
                </>
              }
              key="unpaid"
            />
            <Tabs.Tab title="PAID FEES" key="paid" />
          </Tabs>
          {/*parseFloat(totalBalance) > 0 && (
            <div
              className="mt-3 fs-6 text-center btn btn-danger w-100 mb-3"
              data-aos="zoom-in"
            >
              Total Balance : {totalBalance}
            </div>
          )*/}

          {activeTab == "paid" && (
            <div data-aos="zoom-in">
              {billList.length > 0 && (
                <>
                  <Card>
                    <Card.Body className="p-0">
                      <div className="stu-fee-paid-list">
                        {billList.map((item, i) => {
                          return (
                            <List header={semesterValue(item[0].semester)}>
                              {getBills(item)}
                            </List>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Card>
                  <div className="py-2"></div>
                </>
              )}
              {billList.length < 1 && acknowldgements.length < 1 && (
                <Card>
                  <Card.Body>
                    <NoData />
                  </Card.Body>
                </Card>
              )}

              {acknowldgements && acknowldgements.length > 0 && (
                <Card>
                  <Card.Header className="card-header-bg text-uppercase fw-bold">
                    Online Paid List
                  </Card.Header>
                  <Card.Body>
                    <List>
                      {acknowldgements.map((item, i) => {
                        return (
                          <List.Item
                            prefix={<FileOutline />}
                            description={momentDate(
                              item[0].payment_on,
                              "DD-MMM-YYYY"
                            )}
                            extra={<>Rs. {itemsTotal(item)}</>}
                            onClick={(d) => viewBillClick(item, "Receipt")}
                          >
                            {item[0].order_no}
                          </List.Item>
                        );
                      })}
                    </List>
                  </Card.Body>
                </Card>
              )}
            </div>
          )}

          {activeTab == "unpaid" && (
            <>
              {unpaidList && unpaidList.length > 0 && (
                <Card data-aos="zoom-in">
                  <Card.Body className="p-0">
                    {isInTimeRange && allowPayment && (
                      <List>
                        {unpaidList.map((item, i) => {
                          return (
                            <List.Item
                              extra={<>Rs. {itemsTotal(item)}</>}
                              clickable
                              onClick={(d) => {
                                setUnPaidSingleData(item);
                                setShowUnpaidDetails(true);
                              }}
                            >
                              {semesterValue(item[0].semester)}
                            </List.Item>
                          );
                        })}
                      </List>
                    )}
                  </Card.Body>
                </Card>
              )}
              {!allowPayment && (
                <Card className="text-center mt-2">
                  <p className="fw-bold p-0 m-0 mt-1">
                    The payment portal has been closed. Kindly contact the
                    office for further details..
                  </p>
                </Card>
              )}
              {allowPayment &&
                (isInTimeRange ? (
                  <Card className="text-center mt-2">
                    <p className="fw-bold p-0 m-0 mt-1">
                      You are allowed to make the payment now.
                    </p>
                    <p className="p-0 m-0 mt-1">
                      Payment can be made between <b>{startTime}</b> and{" "}
                      <b>{endTime}</b>.
                    </p>
                  </Card>
                ) : (
                  <Card className="text-center mt-2">
                    <p className="fw-bold p-0 m-0 mt-1">
                      You are not allowed to make the payment at this time.
                    </p>
                    <p className="p-0 m-0 mt-1">
                      Payments are only allowed between <b>{startTime}</b> and{" "}
                      <b>{endTime}</b>.
                    </p>
                  </Card>
                ))}

              {unpaidList.length < 1 && (
                <Card>
                  <Card.Body>
                    <NoData />
                  </Card.Body>
                </Card>
              )}
            </>
          )}
        </div>
      </div>

      {showFeeModal && (
        <Modal
          show={showFeeModal}
          onHide={(e) => {
            setShowFeeModal(false);
            setViewData([]);
          }}
          backdrop="static"
        >
          <Modal.Header closeButton>Fee Summary</Modal.Header>
          <Modal.Body>
            <Card className="mb-2">
              <Card.Header>Un Paid</Card.Header>

              <Card.Body>
                {getTypeRecords(viewData, "unpaid").map((item, i) => {
                  return (
                    <Row className="py-1">
                      <Col md={9} sm={9} xs={9}>
                        {item.category_name}
                      </Col>
                      <Col md={3} sm={3} xs={3} className="text-end">
                        {item.fee_amount}
                      </Col>
                    </Row>
                  );
                })}
              </Card.Body>
            </Card>
            <Card>
              <Card.Header>Paid</Card.Header>
              <Card.Body>
                {getTypeRecords(viewData, "paid").map((item, i) => {
                  return (
                    <Row className="py-1">
                      <Col md={9} sm={9} xs={9}>
                        {item.category_name}
                      </Col>
                      <Col md={3} sm={3} xs={3} className="text-end">
                        {item.fee_amount}
                      </Col>
                    </Row>
                  );
                })}
              </Card.Body>
            </Card>
          </Modal.Body>
        </Modal>
      )}

      {/*showPay && (
        <Modal show={showPay} backdrop="static">
          <Modal.Body>
            <OnlinePay
              dataSource={getTypeRecords(viewData, "unpaid")}
              onCancel={(e) => {
                setShowPay(false);
                setViewData([]);
              }}
            />
          </Modal.Body>
        </Modal>
      )*/}

      {/*<Popup
        visible={showUnpaidDetails}
        position="right"
        onClose={() => {
          closeUnpaidPopup();
        }}
        onMaskClick={() => {
          closeUnpaidPopup();
        }}
      >
        <div className="bg-white p-3 fee_due_details_popup">
          <div
            onClick={(e) => closeUnpaidPopup()}
            className="pb-3 fw-bold"
            style={{ fontSize: "14px" }}
          >
            <i className="fa-solid fa-arrow-left me-2"></i> Fee Due Details
          </div>
          {showUnpaidDetails && (
            <div className="fee_due_details_popup_content">
              <OnlinePay
                dataSource={
                  payScreenType == "bysem"
                    ? unPaidSingleData
                    : unpaidList.flat(2)
                }
                onCancel={() => closeUnpaidPopup()}
              />
            </div>
          )}
        </div>
      </Popup>*/}

      <MuiModalWindow
        title="Fee Due Details"
        open={showUnpaidDetails}
        onClose={(e) => closeUnpaidPopup()}
      >
        {showUnpaidDetails && (
          <div className="container-sm">
            <OnlinePay
              dataSource={
                payScreenType == "bysem" ? unPaidSingleData : unpaidList.flat(2)
              }
              onCancel={() => closeUnpaidPopup()}
            />
          </div>
        )}
      </MuiModalWindow>

      {printAck && printAckData.length > 0 && (
        <OnlinePay_Receipt dataSource={printAckData} onSuccess={printSuccess} />
      )}
      {printBill && printAckData.length > 0 && (
        <Fee_ReceiptPrint dataSource={printAckData} onSuccess={printSuccess} />
      )}
    </>
  );
};
export default MyFees;
